function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Log In Required"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Please log in and try again"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Log In"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React, { useEffect } from "react";
import { t } from "ttag";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import { clean as cleanSession } from "../../services/session-service";
import useSearchParams from "../../hooks/useSearchParams";
import Layout from "./Layout";
var HTTP401 = function() {
    useTranslation();
    var history = useHistory();
    var query = useSearchParams();
    var next = query.get("next");
    useEffect(function() {
        cleanSession();
    }, []);
    return /*#__PURE__*/ React.createElement(Layout, {
        title: t(_templateObject()),
        body: t(_templateObject1())
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        onClick: function() {
            return history.replace("/login?next=".concat(next && next !== "/login" ? next : ""));
        }
    }, t(_templateObject2())));
};
export default HTTP401;
